"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var component_svg_1 = __importDefault(require("@doordash/component-svg"));
var React = __importStar(require("react"));
/* tslint:disable:max-line-length */
var Amex = function (_a) {
    var size = _a.size;
    return (React.createElement(component_svg_1["default"], { height: size, width: size, viewBox: "0 0 200 120" },
        React.createElement("linearGradient", { gradientUnits: "userSpaceOnUse", x1: "187.342", y1: "3564.816", x2: "13.247", y2: "3503.596", gradientTransform: "translate(0 -3474.102)" },
            React.createElement("stop", { offset: "0", stopColor: "#51BCEA" }),
            React.createElement("stop", { offset: "1", stopColor: "#3078BC" })),
        React.createElement("path", { fill: "#54A1D4", d: "M192.3 120H7.7c-4.2 0-7.7-3.5-7.7-7.7V7.7C0 3.5 3.5 0 7.7 0h184.6c4.2 0 7.7 3.5 7.7 7.7v104.7c0 4.1-3.5 7.6-7.7 7.6z" }),
        React.createElement("path", { fill: "#FFFFFF", d: "M162.8 60.1L179 42.5h-11L157.4 54l-10.2-11.5h-33.4v35h32.9l10.6-11.6 10.2 11.6h10.8l-15.5-17.4zm-20.3 10.1H122v-7h18.2V56H122v-6.4h20.8l9.1 10.2-9.4 10.4zm-95-7.7l-5.6-13.9-5.6 13.9m74.4 15h-8.5V50.1L90.1 77.5h-7.3L70.7 50.1v27.4h-17l-3.2-7.8H33.2L30 77.5h-9l14.9-35h12.3l14.1 33.1V42.5H76l10.9 23.7 10-23.7h13.8v35z" })));
};
/* tslint:enable:max-line-length */
exports["default"] = Amex;
